import { observable } from "mobx";

/**
 * @module:  招聘项目组件状态store
 * @author: Liang Huang 
 * @date: 2020-02-19 15:08:11 
 */

class Comp {
  /**
   * 候选人 企业未认证弹窗
   */
  @observable candidateVerifyModal: boolean = false;
  /**
   * 找人才 企业未认证弹窗
   */
  @observable resumeVerifyModal: boolean = false;

}

export default Comp;
